<template>
  <div class="container-fluid py-4">

    <!-- Loader -->
    <div v-if="isLoading" class="text-center my-5">
      <div class="spinner-border text-primary" role="status" style="width: 4rem; height: 4rem;">
        <span class="visually-hidden">Chargement...</span>
      </div>
      <p class="mt-2">Chargement du traitement...</p>
    </div>

    <div v-else>
      <!-- En-tête -->
      <div class="d-flex justify-content-between align-items-center mb-4 flex-wrap">
        <h3 class="text-primary fw-bold">
          <i class="bi bi-clipboard-heart me-2"></i> Traitement de la consultation
        </h3>
        <router-link hidden class="btn btn-outline-secondary" :to="{ name: 'consultations_patient',params: { id: consultation.patient?.id }  }">
          <i class="bi bi-arrow-left-circle me-1"></i> Retour à la liste
        </router-link>
      </div>

      <!-- Informations Patient -->
      <div class="card shadow-sm rounded-4 p-4 mb-4 bg-light">
        <h5 class="mb-3 text-primary fw-bold">
          <i class="bi bi-person-vcard me-2"></i> Informations du patient
        </h5>
        <div class="row">
          <div class="col-md-6 mb-2">
            <p><strong>N° Dossier :</strong> {{ consultation.patient?.numeroDossier }}</p>
            <p><strong>Nom :</strong> {{ consultation.patient?.nom }} {{ consultation.patient?.prenom }}</p>
            <p><strong>Âge :</strong> {{ calculerAge(consultation.patient?.dateNaissance) }} ans</p>
          </div>
          <div class="col-md-6 mb-2">
            <p><strong>N° Consultation :</strong> {{ consultation.numConsultation }}</p>
            <p><strong>Type :</strong>
              <span class="badge bg-info text-dark">{{ consultation.type?.nom }}</span>
            </p>
            <p><strong>Statut :</strong>
              <span :class="consultation.statut === 'Terminée' ? 'badge bg-success' : 'badge bg-warning text-dark'">
                {{ consultation.statut }}
              </span>
            </p>
          </div>
        </div>
      </div>

      <!-- Onglets -->
      <ul class="nav nav-tabs mb-3">
        <li class="nav-item" v-for="tab in tabs" :key="tab.name">
          <a href="#" class="nav-link" :class="{ active: activeTab === tab.name }"
             @click.prevent="activeTab = tab.name">
            <i :class="tab.icon" class="me-2"></i> {{ tab.label }}
          </a>
        </li>
      </ul>

      <!-- Contenu des onglets -->
      <div class="card shadow-sm rounded-4 p-4 border-0">

        <!-- Diagnostic & Motif -->
        <div v-if="activeTab === 'diagnostic'">
          <h5 class="mb-3 text-success fw-bold"><i class="bi bi-heart-pulse me-2"></i> Diagnostic & Motif</h5>
          <div class="mb-3">
            <label class="form-label fw-semibold">
              <i class="bi bi-chat-left-text me-2 text-primary"></i> Motif
            </label>
            <input v-model="consultation.motif" required class="form-control" placeholder="Motif de la consultation..."/>
          </div>
          <div class="mb-3">
            <label class="form-label fw-semibold">
              <i class="bi bi-activity text-danger me-2"></i> Diagnostic
            </label>
            <textarea v-model="consultation.diagnostic" rows="4" class="form-control"
                      placeholder="Entrer le diagnostic médical..." required></textarea>
          </div>
          <div class="text-end">
            <button class="btn btn-outline-success" @click="saveSection('diagnostic')">
              <i class="bi bi-save me-1"></i> Enregistrer le diagnostic
            </button>
          </div>
        </div>

        <!-- Examens -->
        <div v-if="activeTab === 'examens'">
          <h5 class="mb-3 text-info fw-bold">
            <i class="bi bi-file-medical me-2"></i> Examens prescrits
          </h5>

          <div v-for="(exam, index) in examens" :key="index" class="border rounded p-3 mb-3 shadow-sm">
            <div class="row g-2 mb-2 align-items-end">

              <!-- Type d'examen (select) -->
              <div class="col-md-4">
            <Multiselect
  v-model="exam.serviceId"
  :options="services"
  valueProp="id"
  label="label"
  searchable
  placeholder="Rechercher un examen..."
/>
              </div>

              <!-- Nom de l'examen -->
              <div class="col-md-6">
                <input
                  type="text"
                  v-model="exam.type"
                  class="form-control"
                  placeholder="Nom de l'examen (ex : Glycémie, Hémogramme...)"
                  required
                />
              </div>
              <!-- Bouton imprimer examen individuel -->
          

              <div class="col-md-2 text-end">
                <button class="btn btn-outline-primary me-2" @click="imprimerExamenIndividuel(index)">
             <i class="bi bi-printer"></i>
           </button>
                <button class="btn btn-outline-danger" @click="removeExamen(index)">
                  <i class="bi bi-x-circle"></i>
                </button>
              </div>
            </div>

            <!-- Détails / Précision -->
            <div class="mb-2">
              <textarea
                v-model="exam.precision_"
                class="form-control"
                rows="2"
                placeholder="Précisions sur l’examen (ex : à jeun, région à examiner, durée, etc.)"
                required
              ></textarea>
            </div>
            <div class="mb-2">
    <label class="form-label fw-semibold">Résultat</label>
    <textarea
      v-model="exam.resultat"
      class="form-control"
      rows="2"
      placeholder="Résultat de l’examen"
    ></textarea>
  </div>
          </div>

          <button class="btn btn-outline-primary mb-3" @click="addExamen">
            <i class="bi bi-plus-circle me-1"></i> Ajouter un examen
          </button>

          <div class="text-end">
            <button class="btn btn-outline-success" @click="saveSection('examens')">
              <i class="bi bi-save me-1"></i> Enregistrer les examens
            </button>
           <!-- <button class="btn btn-outline-secondary ms-2" @click="imprimerExamens">
              <i class="bi bi-printer me-1"></i> Imprimer demande
            </button>-->
          </div>
        </div>

       
        <!-- Ordonnance -->
<div v-if="activeTab === 'ordonnance'">
  <h5 class="mb-3 text-warning fw-bold">
    <i class="bi bi-capsule-pill me-2"></i> Ordonnance
  </h5>

  <!-- Liste des items -->
  <div
    v-for="(item, index) in ordonnance"
    :key="index"
    class="row g-2 mb-3 align-items-end border rounded p-3 shadow-sm bg-light"
  >
    <!-- Médicament -->
    <div class="col-md-3">
      <label class="form-label fw-semibold">Nom produit</label>
      <input
        v-model="item.medicament"
        class="form-control"
        placeholder="Nom du médicament"
        required
      />
    </div>

    <!-- Quantité -->
    <div class="col-md-2">
      <label class="form-label fw-semibold">Quantité</label>
      <input
        type="number"
        min="1"
        v-model.number="item.quantite"
        class="form-control"
        placeholder="Qté"
      />
    </div>
    <!-- Posologie -->
    <!--<div class="col-md-2">
      <label class="form-label fw-semibold">Posologie</label>
      <input
        type="text"
        v-model.number="item.posologie"
        class="form-control"
        placeholder="posologie"
      />
    </div>-->

    <!-- Fréquence -->
    <div class="col-md-2">
      <label class="form-label fw-semibold">Posologie</label>
      <select v-model="item.frequence_id" class="form-select">
        <option value="">-- Choisir --</option>
        <option v-for="f in frequences" :key="f.id" :value="f.id">
          {{ f.nom }}
        </option>
      </select>
    </div>

    <!-- Durée -->
    <div class="col-md-2">
      <label class="form-label fw-semibold">Durée</label>
      <select v-model="item.duree_id" class="form-select">
        <option value="">-- Choisir --</option>
        <option v-for="d in durees" :key="d.id" :value="d.id">
          {{ d.nom }}
        </option>
      </select>
    </div>

    <!-- Conditionnement -->
    <div class="col-md-2">
      <label class="form-label fw-semibold">Conditionnement</label>
      <select v-model="item.conditionnement_id" class="form-select">
        <option value="">-- Choisir --</option>
        <option v-for="c in conditionnements" :key="c.id" :value="c.id">
          {{ c.nom }}
        </option>
      </select>
    </div>

    <!-- Supprimer -->
    <div class="col-md-1 text-end">
      <button
        class="btn btn-outline-danger mt-4"
        @click="removeMedicament(index)"
      >
        <i class="bi bi-trash"></i>
      </button>
    </div>
  </div>

  <!-- Bouton d’ajout -->
  <button class="btn btn-outline-primary mb-3" @click="addMedicament">
    <i class="bi bi-plus-circle me-1"></i> Ajouter un médicament
  </button>

  <!-- Actions -->
  <div class="text-end mt-3">
    <button class="btn btn-outline-success" @click="saveSection('ordonnance')">
      <i class="bi bi-save me-1"></i> Enregistrer l’ordonnance
    </button>
    <button class="btn btn-outline-secondary ms-2" @click="imprimerOrdonnance">
      <i class="bi bi-printer me-1"></i> Imprimer
    </button>
  </div>
</div>



        <!-- Suivi -->
        <div v-if="activeTab === 'suivi'">
          <h5 class="mb-3 text-primary fw-bold"><i class="bi bi-calendar-check me-2"></i> Suivi</h5>
          <div class="row g-3">
            <div class="col-md-4">
              <label class="form-label">Prochain RDV</label>
              <input type="date" class="form-control" v-model="consultation.prochainRdv" />
            </div>
          </div>
          <div class="text-end mt-3">
            <button class="btn btn-outline-success" @click="saveSection('suivi')">
              <i class="bi bi-save me-1"></i> Enregistrer le suivi
            </button>
          </div>
        </div>

      </div>

      <!-- Clôture consultation -->
      <div class="text-end mt-4">
        <button class="btn btn-success px-4 py-2" @click="cloturerConsultation">
          <i class="bi bi-check-circle me-2"></i> Clôturer la consultation
        </button>
      </div>

    </div>
  </div>
</template>

<script>
import api from '@/api';
import dayjs from 'dayjs';
import Multiselect from '@vueform/multiselect';

export default {
  components: {
    Multiselect
  },
  data() {
    return {
      consultation: {},
      ordonnance: [],
      examens: [],
      typeExamens: [],
      configClinique: {},
      isLoading: false,
      activeTab: 'diagnostic',
      tabs: [
        { name: 'diagnostic', label: 'Diagnostic', icon: 'bi bi-heart-pulse' },
        { name: 'examens', label: 'Examens', icon: 'bi bi-file-medical' },
        { name: 'ordonnance', label: 'Ordonnance', icon: 'bi bi-capsule-pill' },
        { name: 'suivi', label: 'Suivi', icon: 'bi bi-calendar-check' },
      ],
    
      frequences: [],
      durees: [],
      conditionnements: [],
      services: [],
    };
  },
  computed: {
  currentUser() {
    return this.$store.state.user; 
  }
},

  methods: {
    dossier(id) { 
      this.$router.push({ name: 'information_personnelle', params: { id: id } });
     },
     async fetchServices() {
  const res = await api.getItems('services');
  //this.services = res.data.data;
   this.services = res.data.data.map(s => ({
    id: Number(s.id),
    label: `${s.type?.nom || ''} - ${s.nom}` // 🔥 Type + Service
  }));
},
    async fetchConfigClinique() {
    try {
      const res = await api.getItems('configurations'); // ou l'ID correspondant
      this.configClinique = res.data.data?.[0] || {};
      console.log(this.configClinique.nom);
    } catch (err) {
      console.error('Erreur récupération config clinique', err);
      this.configClinique = {};
    }
  },
   async fetchConsultation() {
  this.isLoading = true;
  try {
    const id = this.$route.params.id;
    const res = await api.getItem('consultations', id);
    this.consultation = res.data;
    if (this.consultation.prochainRdv) {
  this.consultation.prochainRdv = this.consultation.prochainRdv.split('T')[0];
}

    // Préparer les examens pour le v-model
    this.examens = (res.data.examenPrescrits || []).map(exam => ({
  ...exam,
  serviceId: exam.service?.id 
    ? Number(exam.service.id) 
    : exam.typeExamen?.id   
      ? Number(exam.typeExamen.id)
      : null,
  type: exam.type || '',
  precision_: exam.precision_ || '',
}));
   console.log(this.examens);
    

    // Préparer l’ordonnance pour le v-model
  const ord = res.data.ordonnances?.[0]; 
this.ordonnance = (ord?.ordonnanceItems || []).map(item => ({
   id: item.id || null,
  medicament: item.medicament || '',
  quantite: item.quantite || '',
  frequence_id: item.frequence?.id || '',
  duree_id: item.duree?.id || '',
  conditionnement_id: item.conditionnement?.id || ''
}));


    console.log('OrdonnanceItems récupérés :', ord?.ordonnanceItems);

   

  } catch (err) {
    console.error(err);
  } finally {
    this.isLoading = false;
  }
},


    calculerAge(dateNaissance) {
      return dateNaissance ? dayjs().diff(dayjs(dateNaissance), 'year') : '-';
    },

    async fetchTypeExamens() {
      try {
        const res = await api.getItems('services'); 
        this.typeExamens = res.data.data;
      } catch (err) {
        console.error('Erreur récupération types d’examen', err);
      }
    },

    addExamen() {
  this.examens.push({
    id: null,
    serviceId: null,
    type: '',
    precision_: '',

  });
},

    async removeExamen(index) {
      const examen = this.examens[index];

      if (examen.id) {
        console.log(examen.id);
        if (!confirm('Voulez-vous vraiment supprimer cet examen ?')) return;
        try {
          await api.deleteItem('examens', examen.id);
          this.examens.splice(index, 1);
          alert('Examen supprimé avec succès.');
        } catch (err) {
          console.error(err);
          alert("Une erreur est survenue lors de la suppression.");
        }
      } else {
        this.examens.splice(index, 1);
      }
    },

    addMedicament() {
      this.ordonnance.push({ medicament: '', quantite: 1, posologie: '',frequence_id: '',duree_id: '', conditionnement_id: '',
      });
    },

    async removeMedicament(index) {
  const medicament = this.ordonnance[index];

  // Si le médicament existe déjà en base (id défini)
  if (medicament.id) {
    if (!confirm('Voulez-vous vraiment supprimer ce médicament ?')) return;

    try {
      //  Appel à l’API pour supprimer l’item d’ordonnance
      await api.deleteItem('ordonnance_items', medicament.id);

      //  Suppression locale dans le tableau
      this.ordonnance.splice(index, 1);

      alert('Médicament supprimé avec succès.');
    } catch (err) {
      console.error(err);
      alert("Une erreur est survenue lors de la suppression du médicament.");
    }
  } else {
    //  Si le médicament n’est pas encore enregistré (pas d’ID)
    this.ordonnance.splice(index, 1);
  }
},


  async saveSection(section) {
  // Validation de base
  if (section === 'diagnostic' && (!this.consultation.motif || !this.consultation.diagnostic)) {
    alert('Veuillez remplir le motif et le diagnostic avant d’enregistrer.');
    return;
  }
  if (section === 'examens' && this.examens.filter(e => e.type.trim() !== '').length === 0) {
    alert('Veuillez ajouter au moins un examen avant d’enregistrer.');
    return;
  }
  if (section === 'ordonnance' && this.ordonnance.filter(o => o.medicament.trim() !== '').length === 0) {
    alert('Veuillez ajouter au moins un médicament avant d’enregistrer.');
    return;
  }
  if (section === 'suivi' && !this.consultation.prochainRdv) {
    alert('Veuillez indiquer la date du prochain rendez-vous.');
    return;
  }

  if((this.consultation.medecin)) {
   if (this.consultation.medecin.id !== this.$store.state.user?.id) {
    alert('Vous n\' êtes pas le medecin traitant');
    return ;
  } 
  } 

  try {
    this.isLoading = true;
    const payload = {
      medecin_id: this.$store.state.user?.id,
      diagnostic: this.consultation.diagnostic,
      motif: this.consultation.motif,
      statut: 'En cours',
      prochainRdv: this.consultation.prochainRdv || null,
      examens: this.examens.map(e => ({
        id: e.id || null,
        serviceId: e.serviceId || null,
        type: e.type || '',
        precision_: e.precision_ || '',
        resultat: e.resultat || ''
      })),
      ordonnance: this.ordonnance.map(o => ({
        id: o.id || null,
        medicament: o.medicament || '',
        quantite: o.quantite || 1,
        posologie: o.posologie || '',
        frequence_id: o.frequence_id || null,
        duree_id: o.duree_id || null,
        conditionnement_id: o.conditionnement_id || null,
        estRetire: o.estRetire || false
      }))
    };

    
   await api.updateItem('consultations', `${this.consultation.id}/traitements`, payload);

    //alert(`${section} enregistré avec succès.`);

    // Recharge la consultation après mise à jour
    await this.fetchConsultation(this.consultation.id);

  } catch (err) {
    console.error("Erreur lors de l'envoi :", err);
    alert("Erreur lors de la sauvegarde de la section.");
  } finally {
    this.isLoading = false;
  }
}

,


    async cloturerConsultation() {
      try {
        await api.updateItem('consultations', this.consultation.id, { statut: 'Terminée' });
        //alert('Consultation clôturée avec succès.');
        this.$router.push({ name: 'consultations_' });
        //window.location.reload();
      } catch (err) {
        console.error(err);
        alert("Erreur lors de la clôture.");
      }
    },
    async chargerConfigurations() {
  this.isLoading = true;
  try {
    const [freqRes, dureeRes, condRes] = await Promise.all([
      api.getItems('frequences'),
      api.getItems('durees'),
      api.getItems('conditionnements'),
    ]);

    this.frequences = Array.isArray(freqRes.data.data) ? freqRes.data.data : [];
    this.durees = Array.isArray(dureeRes.data.data) ? dureeRes.data.data : [];
    this.conditionnements = Array.isArray(condRes.data.data) ? condRes.data.data : [];
  } catch (err) {
    console.error("Erreur chargement des données configurables :", err);
  } finally {
    this.isLoading = false;
  }
}
,

   /* imprimerExamens() {
      window.print();
    },
*/ formatDate(date) {
    if (!date) return "—";
    return dayjs(date).format('DD/MM/YYYY');
  },
/*imprimerExamens() {
  if (!this.consultation) return;

  const config = this.configClinique || {};
  const examens = this.examens || [];
  const patient = this.consultation.patient || {};
  const medecin = this.currentUser || {};

  const dateConsultation = this.formatDate(this.consultation.createdAt);
  const reference = `DEM-${this.consultation.id}-${new Date().getFullYear()}`;
  const agePatient = this.calculerAge(patient.dateNaissance);

  const baseURL = process.env.VUE_APP_API_BASE_URL || "http://127.0.0.1:8000";
  const logoUrl = config.logo
    ? (config.logo.startsWith("http") ? config.logo : `${baseURL}${config.logo}`)
    : "";

  const printWindow = window.open("", "_blank");

  const htmlContent = `
    <html>
      <head>
        <title>Bulletin de Consultation et d’Examen</title>
        <style>
          @page {
            size: A4;
            margin: 2cm;
          }

          body {
            font-family: "Times New Roman", serif;
            color: #000;
            font-size: 14px;
            line-height: 1.6;
            margin: 0;
            padding: 0;
          }

          .document {
            width: 100%;
            padding: 1cm;
            border: 1px solid #0056b3;
            box-sizing: border-box;
            overflow: hidden;
          }

          header {
            display: flex;
            justify-content: space-between;
            border-bottom: 2px solid #0056b3;
            padding-bottom: 10px;
            margin-bottom: 10px;
          }

          header img {
            width: 80px;
            height: 80px;
            object-fit: contain;
          }

          .info {
            flex: 1;
            margin-left: 10px;
          }

          .info h2 {
            margin: 0;
            color: #0056b3;
            font-size: 20px;
          }

          .info p {
            margin: 2px 0;
            font-size: 13px;
          }

          h3 {
            text-align: center;
            color: #0056b3;
            text-decoration: underline;
            margin-top: 10px;
          }

          .patient-info, .examens, .clinique {
            margin-top: 10px;
          }

          .patient-info p {
            margin: 4px 0;
          }

          table {
            width: 100%;
            border-collapse: collapse;
            margin-top: 10px;
            
            page-break-inside: avoid;
          }

          th, td {
            border: 1px solid #0056b3;
            padding: 24px;
            font-size: 13px;
          }

          th {
            background-color: #e6f0ff;
            text-align: center;
          }

          .footer {
            display: flex;
            justify-content: space-between;
            margin-top: 30px;
            font-size: 13px;
          }

          .signature {
            text-align: right;
            margin-top: 40px;
            font-size: 14px;
          }

          .signature strong {
            text-decoration: underline;
          }
        </style>
      </head>

      <body>
        <div class="document">
          <header>
            <div style="display:flex; align-items:center;">
              ${logoUrl ? `<img src="${logoUrl}" alt="Logo Clinique">` : ""}
              <div class="info">
                <h2>${config.nom || "Clinique Médicale"}</h2>
                <p>${config.adresse || ""}</p>
                <p>Tél : ${config.telephone || ""}</p>
                ${config.email ? `<p>Email : ${config.email}</p>` : ""}
              </div>
            </div>
            <div style="text-align:right;">
              <p><strong>N° :</strong> ${reference}</p>
              <p><strong>Date :</strong> ${dateConsultation}</p>
            </div>
          </header>

          <h3>BULLETIN DE CONSULTATION ET D’EXAMEN</h3>

          <div class="patient-info">
            <p><strong>Concernant :</strong> ${patient.nom || ""} ${patient.prenom || ""}</p>
            <p><strong>Âge :</strong> ${agePatient || "—"} ans &nbsp;&nbsp; <strong>Sexe :</strong> ${patient.genre || "—"}</p>
            <p><strong>Adresse :</strong> ${patient.adresse || "—"}</p>
          </div>

          <div class="examens">
            <table>
              <thead>
                <tr>
                  <th>Nature de l'examen</th>
                  <th>Résultat</th>
                </tr>
              </thead>
              <tbody>
                ${
                  examens.length
                    ? examens
                        .map(
                          (ex) => `
                            <tr>
                              <td>${ex.typeExamen?.nom || ex.type || "—"}</td>
                              <td></td>
                            </tr>`
                        )
                        .join("")
                    : `<tr><td colspan="2" style="text-align:center;">Aucun examen prescrit</td></tr>`
                }
              </tbody>
            </table>
          </div>

          <div class="clinique">
            <h4>Renseignements cliniques :</h4>
            <p>${this.consultation.observation || "........................................"}</p>
          </div>

          <div class="footer">
            <div>
              <p>Bamako, le ${new Date().toLocaleDateString()}</p>
              <p><strong>Le Médecin traitant :</strong> Dr. ${medecin.nom || ""} ${medecin.prenom || ""}</p>
            </div>
            <div class="signature">
              <p>Signature & Cachet</p>
            </div>
          </div>
        </div>
      </body>
    </html>
  `;

  printWindow.document.write(htmlContent);
  printWindow.document.close();

  printWindow.onload = function () {
    printWindow.focus();
    printWindow.print();
    printWindow.close();
  };
}*/
async imprimerExamenIndividuel(index) {
  const exam = this.examens[index];
  if (!exam) return;

  const config = this.configClinique || {};
  const patient = this.consultation.patient || {};
  const medecin = this.currentUser || {};

  const dateConsultation = this.formatDate(this.consultation.createdAt);
  const reference = `EXAM-${this.consultation.id}-${new Date().getFullYear()}`;
  const agePatient = this.calculerAge(patient.dateNaissance);

  const baseURL = process.env.VUE_APP_API_BASE_URL || "http://127.0.0.1:8000";

  const logoUrl = config.logo
    ? (config.logo.startsWith("http") ? config.logo : `${baseURL}${config.logo}`)
    : "";

  const serviceNom =
    this.services.find(s => s.id === exam.serviceId)?.nom || "—";

  const printWindow = window.open("", "_blank");

  const html = `
<!DOCTYPE html>
<html>
<head>
  <title>Demande d'examen</title>

  <style>
    @page { size: A4; margin: 2cm; }

    body {
      font-family: "Times New Roman", serif;
      font-size: 14px;
      color: #000;
      margin: 0;
    }

    header {
      display: flex;
      justify-content: space-between;
      border-bottom: 2px solid #0056b3;
      padding-bottom: 10px;
      margin-bottom: 20px;
    }

    header img {
      width: 80px;
      height: 80px;
      object-fit: contain;
    }

    .clinic-info h2 {
      margin: 0;
      color: #0056b3;
    }

    .clinic-info p {
      margin: 2px 0;
      font-size: 13px;
    }

    h3 {
      text-align: center;
      color: #0056b3;
      text-decoration: underline;
      margin: 20px 0;
    }

    table {
      width: 100%;
      border-collapse: collapse;
      margin-top: 15px;
    }

    th, td {
      border: 1px solid #0056b3;
      padding: 10px;
      font-size: 13px;
    }

    th {
      background-color: #e6f0ff;
      text-align: center;
    }

    .patient-box {
      margin-top: 10px;
    }

    .patient-box p {
      margin: 4px 0;
    }

    .observation {
      margin-top: 20px;
    }

    .signature {
      margin-top: 50px;
      text-align: right;
    }

    footer {
      position: fixed;
      bottom: 0;
      left: 0;
      right: 0;
      border-top: 1px solid #0056b3;
      padding-top: 5px;
      font-size: 12px;
      display: flex;
      justify-content: space-between;
    }
  </style>
</head>

<body>

<header>
  <div style="display:flex; gap:10px;">
    ${logoUrl ? `<img src="${logoUrl}" alt="Logo">` : ""}
    <div class="clinic-info">
      <h2>${config.nom || "CLINIQUE MÉDICALE"}</h2>
      <p>${config.adresse || ""}</p>
      <p>Tél : ${config.telephone || ""}</p>
      ${config.email ? `<p>Email : ${config.email}</p>` : ""}
    </div>
  </div>

  <div style="text-align:right;">
    <p><strong>N° :</strong> ${reference}</p>
    <p><strong>Date :</strong> ${dateConsultation}</p>
  </div>
</header>

<h3>DEMANDE D’EXAMEN</h3>

<div class="patient-box">
  <p><strong>Patient :</strong> ${patient.nom || ""} ${patient.prenom || ""}</p>
  <p><strong>N° Dossier :</strong> ${patient.numeroDossier || "—"}</p>
  <p><strong>Âge :</strong> ${agePatient || "-"} ans</p>
</div>

<table>
  <thead>
    <tr>
      <th>Type service</th>
      <th>Service</th>
      <th>Précision</th>
    </tr>
  </thead>
  <tbody>
    <tr>
      <td>${exam.service?.type?.nom || "—"}</td>
      <td>${exam.service?.nom || exam.type || "—"}</td>
      <td>${exam.precision_ || ""}</td>
    </tr>
  </tbody>
</table>

<div class="observation">
  <p><strong>Observation :</strong></p>
  <p>${this.consultation.observation || "..........................................."}</p>
</div>

<div class="signature">
  <p>Bamako, le ${new Date().toLocaleDateString()}</p>
  <p><strong>Dr. ${medecin.nom || ""} ${medecin.prenom || ""}</strong></p>
  <br><br>
  <p>Signature & cachet</p>
</div>

<footer>
  <span>${config.nom || ""} - ${config.adresse || ""}</span>
  <span>© ${new Date().getFullYear()}</span>
</footer>

</body>
</html>
`;

  printWindow.document.write(html);
  printWindow.document.close();

  printWindow.onload = () => {
    printWindow.focus();
    printWindow.print();
    printWindow.close();
  };
},



 imprimerExamens() {
  if (!this.consultation) return;

  const config = this.configClinique || {};
  const examens = this.examens || [];
   if (!this.examens || this.examens.length === 0) {
     this.fetchConsultation(); // fonction qui récupère les examens depuis l'API
  }
  const patient = this.consultation.patient || {};
  const medecin = this.currentUser || {};

  const dateConsultation = this.formatDate(this.consultation.createdAt);
  const reference = `DEM-${this.consultation.id}-${new Date().getFullYear()}`;
  const agePatient = this.calculerAge(patient.dateNaissance);

  const baseURL = process.env.VUE_APP_API_BASE_URL || "http://127.0.0.1:8000";
  const logoUrl = config.logo
    ? (config.logo.startsWith("http") ? config.logo : `${baseURL}${config.logo}`)
    : "";

  const printWindow = window.open("", "_blank");

  const htmlContent = `
    <html>
      <head>
        <title>Bulletin de Consultation et d’Examen</title>
        <style>
          @page {
            size: A4;
            margin: 2cm;
          }

          body {
            font-family: "Times New Roman", serif;
            color: #000;
            font-size: 14px;
            line-height: 1.6;
            margin: 0;
            padding: 0;
          }

          /* ✅ Fixe header et footer */
          header {
            position: fixed;
            top: 0;
            left: 0;
            right: 0;
            height: 120px;
            display: flex;
            justify-content: space-between;
            border-bottom: 2px solid #0056b3;
            padding: 10px 2cm;
          }

          footer {
            position: fixed;
            bottom: 0;
            left: 0;
            right: 0;
            height: 80px;
            border-top: 2px solid #0056b3;
            padding: 10px 2cm;
            font-size: 13px;
            display: flex;
            justify-content: space-between;
            align-items: center;
          }

          /* ✅ Espace réservé pour ne pas que le contenu passe sous header/footer */
          .content {
            margin-top: 150px;
            margin-bottom: 100px;
            padding: 0 1cm;
          }

          header img {
            width: 80px;
            height: 80px;
            object-fit: contain;
          }

          .info {
            flex: 1;
            margin-left: 10px;
          }

          .info h2 {
            margin: 0;
            color: #0056b3;
            font-size: 20px;
          }

          .info p {
            margin: 2px 0;
            font-size: 13px;
          }

          h3 {
            text-align: center;
            color: #0056b3;
            text-decoration: underline;
            margin-top: 10px;
          }

          .patient-info, .examens, .clinique {
            margin-top: 10px;
          }

          .patient-info p {
            margin: 4px 0;
          }

          table {
            width: 100%;
            border-collapse: collapse;
            margin-top: 10px;
            page-break-inside: avoid; /* évite la coupure des tableaux */
          }

          th, td {
            border: 1px solid #0056b3;
            padding: 24px;
            font-size: 13px;
          }

          th {
            background-color: #e6f0ff;
            text-align: center;
          }

          .signature {
            text-align: right;
            font-size: 14px;
          }

          /* ✅ Forcer un saut de page propre */
          .page-break {
            page-break-after: always;
          }

          @media print {
            header, footer {
              position: fixed;
            }
          }
        </style>
      </head>

      <body>
        <!-- ✅ En-tête répété -->
        <header>
          <div style="display:flex; align-items:center;">
            ${logoUrl ? `<img src="${logoUrl}" alt="Logo Clinique">` : ""}
            <div class="info">
              <h2>${config.nom || "Clinique Médicale"}</h2>
              <p>${config.adresse || ""}</p>
              <p>Tél : ${config.telephone || ""}</p>
              ${config.email ? `<p>Email : ${config.email}</p>` : ""}
            </div>
          </div>
          <div style="text-align:right;">
            <p><strong>N° :</strong> ${reference}</p>
            <p><strong>Date :</strong> ${dateConsultation}</p>
          </div>
        </header>

        <!-- ✅ Contenu principal -->
        <div class="content">
          <h3>BULLETIN DE CONSULTATION ET D’EXAMEN</h3>

          <div class="patient-info">
            <p><strong>Concernant :</strong> ${patient.nom || ""} ${patient.prenom || ""}</p>
            <p><strong>Âge :</strong> ${agePatient || "—"} ans &nbsp;&nbsp;
            <strong>Sexe :</strong> ${patient.genre || "—"}</p>
            <p><strong>Adresse :</strong> ${patient.adresse || "—"}</p>
          </div>

          <div class="examens">
            <table>
              <thead>
                <tr>
                  <th>Nature de l'examen</th>
                  <th>Résultat</th>
                </tr>
              </thead>
              <tbody>
                ${
                  examens.length
                    ? examens
                        .map(
                          (ex) => `
                            <tr>
                              <td>${ex.typeExamen?.nom || ex.type || "—"}</td>
                              <td></td>
                            </tr>`
                        )
                        .join("")
                    : `<tr><td colspan="2" style="text-align:center;">Aucun examen prescrit</td></tr>`
                }
              </tbody>
            </table>
          </div>

          <div class="clinique">
            <h4>Renseignements cliniques :</h4>
            <p>${this.consultation.observation || "........................................"}</p>
          </div>
        </div>

        <!-- ✅ Pied de page répété -->
        <footer>
          <div>
            <p>Bamako, le ${new Date().toLocaleDateString()}</p>
            <p><strong>Le Médecin traitant :</strong> Dr. ${medecin.nom || ""} ${medecin.prenom || ""}</p>
          </div>
          <div class="signature">
            <p>Signature & Cachet</p>
          </div>
        </footer>
      </body>
    </html>
  `;

  printWindow.document.write(htmlContent);
  printWindow.document.close();

  printWindow.onload = function () {
    printWindow.focus();
    printWindow.print();
    printWindow.close();
  };
}


,


async imprimerOrdonnance() {
  const ord = this.consultation.ordonnances?.[0];
  if (!ord) return;

  const items = ord?.ordonnanceItems || [];

  const config = this.configClinique || {};
  const patient = this.consultation.patient || {};
  const medecin = this.currentUser || {};

  const dateOrdonnance = this.formatDate(ord.createdAt);
  const reference = ord.numOrdonnance || `ORD-${this.consultation.id}-${new Date().getFullYear()}`;
  const agePatient = this.calculerAge(patient.dateNaissance);

  const baseURL = process.env.VUE_APP_API_BASE_URL || "http://127.0.0.1:8000";

  const logoUrl = config.logo
    ? (config.logo.startsWith("http") ? config.logo : `${baseURL}${config.logo}`)
    : "";

  const rows = items.map((item, i) => `
    <tr>
      <td>${i + 1}</td>
      <td>${item.medicament || "—"}</td>
      <td>${item.quantite || 1}</td>
      <td>${item.frequence?.nom || "—"}</td>
      <td>${item.duree?.nom || "—"}</td>
      <td>${item.conditionnement?.nom || "—"}</td>
    </tr>
  `).join("");

  const printWindow = window.open("", "_blank");

  const html = `
<!DOCTYPE html>
<html>
<head>
  <title>Ordonnance</title>

  <style>
    @page { size: A4; margin: 2cm; }

    body {
      font-family: "Times New Roman", serif;
      font-size: 14px;
      color: #000;
      margin: 0;
    }

    header {
      display: flex;
      justify-content: space-between;
      border-bottom: 2px solid #0056b3;
      padding-bottom: 10px;
      margin-bottom: 20px;
    }

    header img {
      width: 80px;
      height: 80px;
      object-fit: contain;
    }

    .clinic-info h2 {
      margin: 0;
      color: #0056b3;
    }

    .clinic-info p {
      margin: 2px 0;
      font-size: 13px;
    }

    h3 {
      text-align: center;
      color: #0056b3;
      text-decoration: underline;
      margin: 20px 0;
    }

    table {
      width: 100%;
      border-collapse: collapse;
      margin-top: 15px;
    }

    th, td {
      border: 1px solid #0056b3;
      padding: 10px;
      font-size: 13px;
    }

    th {
      background-color: #e6f0ff;
      text-align: center;
    }

    .patient-box {
      margin-top: 10px;
    }

    .patient-box p {
      margin: 4px 0;
    }

    .signature {
      margin-top: 50px;
      text-align: right;
    }

    footer {
      position: fixed;
      bottom: 0;
      left: 0;
      right: 0;
      border-top: 1px solid #0056b3;
      padding-top: 5px;
      font-size: 12px;
      display: flex;
      justify-content: space-between;
    }
  </style>
</head>

<body>

<header>
  <div style="display:flex; gap:10px;">
    ${logoUrl ? `<img src="${logoUrl}" alt="Logo">` : ""}
    <div class="clinic-info">
      <h2>${config.nom || "CLINIQUE MÉDICALE"}</h2>
      <p>${config.adresse || ""}</p>
      <p>Tél : ${config.telephone || ""}</p>
      ${config.email ? `<p>Email : ${config.email}</p>` : ""}
    </div>
  </div>

  <div style="text-align:right;">
    <p><strong>N° :</strong> ${reference}</p>
    <p><strong>Date :</strong> ${dateOrdonnance}</p>
  </div>
</header>

<h3>ORDONNANCE MÉDICALE</h3>

<div class="patient-box">
  <p><strong>Patient :</strong> ${patient.nom || ""} ${patient.prenom || ""}</p>
  <p><strong>N° Dossier :</strong> ${patient.numeroDossier || "—"}</p>
  <p><strong>Âge :</strong> ${agePatient || "-"} ans</p>
</div>

<table>
  <thead>
    <tr>
      <th>#</th>
      <th>Médicament</th>
      <th>Qté</th>
      <th>Posologie</th>
      <th>Durée</th>
      <th>Conditionnement</th>
    </tr>
  </thead>
  <tbody>
    ${rows || `<tr><td colspan="6" style="text-align:center;">Aucun médicament</td></tr>`}
  </tbody>
</table>

<div class="signature">
  <p>Bamako, le ${new Date().toLocaleDateString()}</p>
  <p><strong>Dr. ${medecin.nom || ""} ${medecin.prenom || ""}</strong></p>
  <br><br>
  <p>Signature & cachet</p>
</div>

<footer>
  <span>${config.nom || ""} - ${config.adresse || ""}</span>
  <span>© ${new Date().getFullYear()}</span>
</footer>

</body>
</html>
`;

  printWindow.document.write(html);
  printWindow.document.close();

  printWindow.onload = () => {
    printWindow.focus();
    printWindow.print();
    printWindow.close();
  };
}






  },

  created() {
    this.fetchConsultation();
    //this.fetchTypeExamens();
    this.fetchServices();
    this.fetchConfigClinique();
    this.chargerConfigurations();
    
  },
};
</script>

<style scoped>
.nav-tabs .nav-link.active {
  background-color: #0d6efd;
  color: #fff !important;
  font-weight: 600;
}
.nav-tabs .nav-link {
  color: #495057;
  font-weight: 500;
  transition: 0.3s;
}
.nav-tabs .nav-link:hover {
  background-color: #e9ecef;
}
.form-label {
  font-size: 0.85rem;
  color: #444;
}
.bg-light {
  background-color: #f8fafd !important;
}
.patient-card {
  border: 1px solid #0056b3;
  padding: 12px;
  margin-bottom: 15px;
  border-radius: 6px;
  background: #f0f6ff;
  font-size: 14px;
}

.exam-table {
  width: 100%;
  border-collapse: collapse;
  margin-top: 15px;
  page-break-inside: avoid;
}

.exam-table th {
  border: 1px solid #0056b3;
  padding: 10px;
  background: #e6f0ff;
  font-size: 14px;
  text-align: center;
}

.exam-table td {
  border: 1px solid #0056b3;
  padding: 12px;
  font-size: 14px;
}

</style>
